module.exports = __webpack_public_path__ + "static/media/Wrench.cbec796c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/NewTimeline/assets/Wrench.svg
// module id = 267
// module chunks = 0